
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $6dede80f470fc4d9$export$c4db86264c92e870 = "tracked-phone";
class $6dede80f470fc4d9$export$6a3d66fba6157564 extends HTMLElement {
}
function $6dede80f470fc4d9$export$feb348eaf4031ce3() {
    customElements.define($6dede80f470fc4d9$export$c4db86264c92e870, $6dede80f470fc4d9$export$6a3d66fba6157564);
}



class $4fa2528eaf8658f4$export$1115924fc36cb4f2 {
    constructor(phone){
        this.phone = undefined;
        this.phone = phone;
    }
    isFormatted() {
        return !!this.phone.match(/^(.*([ ()-]).*)$/);
    }
    getDigits() {
        return this.phone.replace(/\D/g, "");
    }
    getFormattedTel() {
        const phoneDigits = this.getDigits().slice(-10);
        let startsWith = "";
        if (phoneDigits.startsWith("800")) startsWith = "8";
        else startsWith = "+7";
        return phoneDigits.replace(/(\d{3})(\d{3})(\d{2})(\d{2})$/g, `${startsWith}$1$2$3$4`);
    }
    // formatLinkTel(element: HTMLElement) {
    //     element.setAttribute('href', 'tel:' + this.getDigits())
    // }
    //
    // formatText(element: HTMLElement) {
    //     element.textContent = this.getFormattedPhone()
    // }
    getFormattedPhone() {
        const phoneDigits = this.getDigits().slice(-10);
        let startsWith = "";
        if (phoneDigits.startsWith("800")) startsWith = "8";
        else startsWith = "+7";
        return phoneDigits.replace(/(\d{3})(\d{3})(\d{2})(\d{2})$/g, `${startsWith} $1 $2-$3-$4`);
    }
}


class $db5a6f595e0412d7$export$f8969add109fffe8 {
    constructor(wrapperNode, linkNode){
        this.onInteractionCallbacks = [];
        this.isCloaked = false;
        this.cloakedAttrName = "cloaked";
        this.isLoading = false;
        this.loadingAttrName = "loading";
        this.isClickDelayed = false;
        this.handleHover = async ()=>{
            this.removeHoverListener();
            this.loadingStart();
            await this.onInteractionTrigger();
            this.loadingFinish();
        };
        this.handleClick = async (e)=>{
            this.startDelayedClick(e);
            if (!this.isLoading) {
                this.loadingStart();
                await this.onInteractionTrigger();
                this.loadingFinish();
            }
        };
        this.wrapperNode = wrapperNode;
        this.linkNode = linkNode;
        this.initialDigits = this.getDigits();
    }
    init() {
        this.cloak();
        this.formatTel();
        this.formatText();
        this.addListeners();
    }
    getWrapperNode() {
        return this.wrapperNode;
    }
    getLinkNode() {
        return this.linkNode;
    }
    revealPhone(phone) {
        this.setPhone(phone);
        this.formatTel();
        this.formatText();
        this.loadingFinish();
        this.uncloak();
        this.removeHoverListener();
        this.removeClickListener();
        this.finishDelayedClick();
    }
    getDigits() {
        const formatter = new (0, $4fa2528eaf8658f4$export$1115924fc36cb4f2)(this.getText());
        return formatter.getDigits();
    }
    getInitialDigits() {
        return this.initialDigits;
    }
    onInteraction(cb) {
        this.onInteractionCallbacks.push(cb);
    }
    getText() {
        return this.getWrapperNode().textContent;
    }
    setTel(value) {
        this.getLinkNode().setAttribute("href", "tel:" + value);
    }
    setText(newValue) {
        this.getWrapperNode().textContent = newValue;
        return newValue;
    }
    getHref() {
        return this.getLinkNode().getAttribute("href");
    }
    getFormattedTel(phone) {
        const formatter = new (0, $4fa2528eaf8658f4$export$1115924fc36cb4f2)(phone);
        return formatter.getFormattedTel();
    }
    getFormattedText(phone) {
        const formatter = new (0, $4fa2528eaf8658f4$export$1115924fc36cb4f2)(phone);
        return formatter.getFormattedPhone();
    }
    formatTel() {
        const formatted = this.getFormattedTel(this.getText());
        this.setTel(formatted);
    }
    formatText() {
        const formatted = this.getFormattedText(this.getText());
        this.setText(formatted);
    }
    loadingStart() {
        this.isLoading = true;
        this.getWrapperNode().setAttribute(this.loadingAttrName, "");
    }
    loadingFinish() {
        this.isLoading = true;
        this.getWrapperNode().removeAttribute(this.loadingAttrName);
    }
    setPhone(phone) {
        this.setText(this.getFormattedText(phone));
        this.setTel(this.getFormattedTel(phone));
    }
    async onInteractionTrigger() {
        for await (const cb of this.onInteractionCallbacks)await cb();
    }
    removeClickListener() {
        this.getWrapperNode().removeEventListener("click", this.handleClick);
    }
    removeHoverListener() {
        this.getWrapperNode().removeEventListener("mouseenter", this.handleHover);
    }
    uncloak() {
        this.isCloaked = false;
        this.getWrapperNode().removeAttribute(this.cloakedAttrName);
    }
    cloak() {
        this.isCloaked = true;
        this.getWrapperNode().setAttribute(this.cloakedAttrName, "");
    }
    addListeners() {
        this.getWrapperNode().addEventListener("mouseenter", this.handleHover);
        this.getWrapperNode().addEventListener("click", this.handleClick);
    }
    startDelayedClick(e) {
        if (this.isCloaked) {
            e.preventDefault();
            this.isClickDelayed = true;
        }
    }
    finishDelayedClick() {
        if (this.isClickDelayed) {
            location.href = this.getHref();
            this.isClickDelayed = false;
        }
    }
}


class $ddcda35218b0a3bf$export$7f7034923e902a9c {
    constructor(rootNode, phonesMap, wrappersSet){
        this.ruPhone = /(?<!\d)((\+7|[,78]) ?(\d{10}|(\(?\d{3}\)? ?\d{3}(?:[ ,\-]?\d{2}){2})))(?!\d)/gim;
        // ruPhone = /(^8|7|\+7)((\d{10})|(\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}))/im;
        this.excludedTags = [
            "script",
            "jdiv"
        ];
        this.phonesMap = phonesMap;
        this.wrappersSet = wrappersSet;
        if (rootNode) this.rootNode = rootNode;
        else this.rootNode = document.body;
    }
    parseAllPhonesAsNodes() {
        const nodesWithPhone = this.findTextNodesWithPhones();
        const wrappedPhones = this.wrapPhones(nodesWithPhone);
        wrappedPhones.forEach((item)=>{
            this.addPhoneItemToMapAndSet(item);
        });
        return wrappedPhones;
    }
    addPhoneItemToMapAndSet(phoneItem) {
        const phone = phoneItem.getInitialDigits();
        // wrappers
        this.wrappersSet.add(phoneItem.getWrapperNode());
        // nodes by phone number
        if (this.phonesMap.has(phone)) {
            const existingSet = this.phonesMap.get(phone);
            existingSet.add(phoneItem);
            this.phonesMap.set(phone, existingSet);
        } else this.phonesMap.set(phone, new Set([
            phoneItem
        ]));
    }
    wrapPhones(textNodes) {
        const result = [];
        for (let textNode of textNodes){
            let parentNode = textNode.parentNode;
            const phones = this.getPhoneMatches(textNode.textContent.trim());
            if (parentNode.nodeName.toLowerCase() === (0, $6dede80f470fc4d9$export$c4db86264c92e870).toLowerCase()) {
                // already wrapped
                if (this.wrappersSet.has(parentNode)) continue;
                else {
                    // console.log('Found broken Phone Wrapper!', parentNode)
                    const result = this.unwrapPhone(parentNode);
                    textNode = result.textNode;
                    parentNode = result.parentNode;
                }
            }
            // Не рассматриваем ситуацию,
            // где в одной ссылке может быть несколько номеров телефонов
            if (parentNode.nodeName.toLowerCase() === "a") {
                // Если телефон найден в ссылке
                const wrapperNode = document.createElement((0, $6dede80f470fc4d9$export$c4db86264c92e870));
                wrapperNode.textContent = textNode.textContent;
                parentNode.replaceChild(wrapperNode, textNode);
                result.push(new (0, $db5a6f595e0412d7$export$f8969add109fffe8)(wrapperNode, parentNode));
            } else if (parentNode.closest("a") && parentNode.closest("a").getAttribute("href").startsWith("tel:")) {
                // Если выше по дереву есть ссылка, проверяем — телефонная ли она.
                const wrapperNode = document.createElement((0, $6dede80f470fc4d9$export$c4db86264c92e870));
                wrapperNode.textContent = textNode.textContent;
                parentNode.replaceChild(wrapperNode, textNode);
                result.push(new (0, $db5a6f595e0412d7$export$f8969add109fffe8)(wrapperNode, parentNode.closest("a")));
            } else {
                // Если это просто номер в тексте
                const newLinkNodes = this.replacePhoneStringsWithLinks(textNode, phones);
                result.push(...newLinkNodes.map((linkNode)=>{
                    const wrapperNode = document.createElement((0, $6dede80f470fc4d9$export$c4db86264c92e870));
                    wrapperNode.textContent = linkNode.textContent;
                    linkNode.textContent = null;
                    linkNode.appendChild(wrapperNode);
                    return new (0, $db5a6f595e0412d7$export$f8969add109fffe8)(wrapperNode, linkNode);
                }));
            }
        }
        return result;
    }
    getPhoneMatches(text) {
        const matches = text.matchAll(this.ruPhone);
        return [
            ...matches
        ].map((match)=>match[1]);
    }
    // findStrings() {
    //     return this.getPhoneMatches(this.rootNode.innerHTML)
    // }
    //  find all nodes that have phone in text
    //  If node (or ony parent node) is link — return it,
    //  else — wrap number inside node in link and return
    //  returns Iterator
    findTextNodesWithPhones() {
        // Find all text nodes
        const textNodesWalker = document.createTreeWalker(this.rootNode, NodeFilter.SHOW_TEXT, (node)=>!this.excludedTags.includes(node.parentNode.nodeName.toLowerCase()) && node.textContent.trim().length > 0 && this.getPhoneMatches(node.textContent.trim()).length > 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT);
        const resultArray = [];
        // Make array of nodes, that contains phones in self content
        while(textNodesWalker.nextNode())resultArray.push(textNodesWalker.currentNode);
        return resultArray;
    }
    makeTelFromPhoneNumber(phone) {
        return phone.replace(/\D/g, "");
    }
    /**
     * Will replace ALL phones in text node,
     * even multiple times,
     * for multiple phone numbers,
     * with links and return new links nodes.
     */ replacePhoneStringsWithLinks(textNode, phones) {
        const parentNode = textNode.parentNode;
        const resultNodes = [
            textNode
        ];
        // for each phone split text nodes and make result array
        phones.forEach((phone)=>{
            const linkElement = document.createElement("a");
            const tel = this.makeTelFromPhoneNumber(phone);
            linkElement.setAttribute("href", "tel:" + tel);
            linkElement.textContent = phone;
            resultNodes.forEach((resultNode, resultNodeIndex)=>{
                if (resultNode.nodeType === Node.TEXT_NODE) {
                    const newStrings = resultNode.textContent.split(phone);
                    const newNodes = [];
                    newStrings.forEach((newString, index)=>{
                        if (newString) newNodes.push(document.createTextNode(newString));
                        if (index < newStrings.length - 1) // if it is not last item — add link element.
                        newNodes.push(linkElement);
                    });
                    // replace splitted text string with new nodes
                    resultNodes.splice(resultNodeIndex, 1, ...newNodes);
                }
            });
        });
        const resultLinksNodes = [];
        resultNodes.forEach((resultNode, resultNodeIndex)=>{
            const uniqueNode = resultNode.cloneNode(true);
            if (resultNodeIndex === 0) parentNode.replaceChild(uniqueNode, textNode);
            else parentNode.appendChild(uniqueNode);
            if (resultNode.nodeType !== Node.TEXT_NODE) resultLinksNodes.push(uniqueNode);
        });
        return resultLinksNodes;
    }
    unwrapPhone(node) {
        const content = node.parentNode.textContent;
        const parentNode = node.parentNode;
        const textNode = document.createTextNode(content);
        parentNode.replaceChild(textNode, node);
        return {
            parentNode: parentNode,
            textNode: textNode
        };
    }
}


var $3114c2c1caeba599$export$e6ace6ff5c5202b3;
(function(Calltracking) {
    Calltracking["AVANTTELECOM"] = "avantelecom";
    Calltracking["CALLTOUCH"] = "calltouch";
})($3114c2c1caeba599$export$e6ace6ff5c5202b3 || ($3114c2c1caeba599$export$e6ace6ff5c5202b3 = {}));


class $975281628826261e$export$93b26a0b8215996b {
    constructor(){
        this.iterations = 0;
        this.interval = undefined;
        this.awaitForWindowObject = (param)=>{
            return new Promise((resolve, reject)=>{
                this.interval = setInterval(()=>{
                    if (window[param]) {
                        clearInterval(this.interval);
                        resolve(window[param]);
                    }
                    if (this.iterations > 1000) {
                        clearInterval(this.interval);
                        reject();
                    }
                }, 50);
            });
        };
    }
}


class $2e539f7ef4ad03c3$export$526382f42139a64a {
    constructor(ctId){
        this.id = ctId;
    }
    async whenLoaded(timeout) {
        const detector = new (0, $975281628826261e$export$93b26a0b8215996b)();
        const timeouter = new Promise((resolve)=>{
            setTimeout(()=>resolve(false), timeout);
        });
        const waiter = detector.awaitForWindowObject("ct");
        const result = await Promise.race([
            timeouter,
            waiter
        ]);
        console.log("CT finished loading", result);
        if (result) {
            this.ct = result;
            return this;
        } else {
            this.ct = undefined;
            return this;
        }
    }
    async getReplacementPhone(searchablePhone, timeout) {
        if (!this.ct) {
            console.error("Calltouch not loaded");
            return null;
        }
        const replacementPhone = this.dynamicReplacement([
            searchablePhone
        ]);
        const timeouter = new Promise((resolve)=>{
            setTimeout(()=>resolve(null), timeout);
        });
        const result = await Promise.race([
            timeouter,
            replacementPhone
        ]);
        console.log("Race result", result);
        return result ?? null;
    }
    dynamicReplacement(subPoolNamesContains) {
        return new Promise((resolve)=>{
            this.ct(this.id, "dynamic_replacement", {
                callback: (success, data)=>{
                    if (data && data[0]) {
                        const newPhoneNumber = data[0].phoneNumber;
                        return resolve(newPhoneNumber);
                    } else {
                        console.error("Incorrect response from Calltouch");
                        return resolve(null);
                    }
                },
                subPoolNamesContains: subPoolNamesContains
            });
        });
    }
}



class $118cb3703dc17eba$export$86b7828ac262effc {
    constructor(metrikaCountId){
        this.metrikaCounterId = metrikaCountId;
    }
    /**
     * Set timeout for waiting metrika to load
     * returns this
     *
     * @param timeout
     */ async whenLoaded(timeout) {
        const detector = new (0, $975281628826261e$export$93b26a0b8215996b)();
        const timeouter = new Promise((resolve)=>{
            setTimeout(()=>resolve(false), timeout);
        });
        const waiter = detector.awaitForWindowObject("ym");
        const result = await Promise.race([
            timeouter,
            waiter
        ]);
        if (result) {
            this.metrika = result;
            return this;
        } else {
            this.metrika = undefined;
            return this;
        }
    }
    /**
     * @param searchablePhone - phone number to search for
     * @param timeout
     * @returns replacement phone number or undefined
     *
     */ async getReplacementPhone(searchablePhone, timeout) {
        const metrikaClientId = await this.getMetrikaClientId();
        console.log(metrikaClientId);
        const timeouter = new Promise((resolve)=>{
            setTimeout(()=>resolve(null), timeout);
        });
        const result = this.getNumberFromAvantelecom(metrikaClientId, searchablePhone);
        const data = await Promise.race([
            timeouter,
            result
        ]);
        return data || null;
    }
    /**
     * @returns metrika client id or undefined
     * @private
     */ getMetrikaClientId() {
        return new Promise((resolve)=>{
            if (!this.metrika) resolve(undefined);
            else this.metrika(this.metrikaCounterId, "getClientID", (clientID)=>{
                resolve(clientID);
            });
        });
    }
    async getNumberFromAvantelecom(metrikaClientId, searchablePhone) {
        const url = `https://calltracker.avantele.com/make-reservation/${metrikaClientId}/${searchablePhone}/`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            return data.number;
        } catch (error) {
            console.error("Error:", error);
            return undefined;
        }
    }
}


class $1010654e42cdef29$export$c30cd198d731db19 {
    constructor(phonesMap, wrappersSet, config){
        this.timeout = 1000;
        this.phonesMap = phonesMap;
        this.wrappersSet = wrappersSet;
        if (config.calltracking === (0, $3114c2c1caeba599$export$e6ace6ff5c5202b3).CALLTOUCH) this.calltrackingService = new (0, $2e539f7ef4ad03c3$export$526382f42139a64a)(config.calltouchId);
        if (config.calltracking === (0, $3114c2c1caeba599$export$e6ace6ff5c5202b3).AVANTTELECOM) this.calltrackingService = new (0, $118cb3703dc17eba$export$86b7828ac262effc)(config.metrikaCounterId);
        if (!this.calltrackingService) console.error("No calltracking service selected");
    }
    processAllPhones() {
        const parser = new (0, $ddcda35218b0a3bf$export$7f7034923e902a9c)(document.body, this.phonesMap, this.wrappersSet);
        const phones = parser.parseAllPhonesAsNodes();
        phones.forEach((phone)=>{
            phone.init();
            phone.onInteraction(async ()=>{
                await this.replacePhone(phone);
            });
        });
        return phones;
    }
    async replacePhone(phoneItem) {
        // console.log('Replacing')
        await this.calltrackingService.whenLoaded(this.timeout).then(async (service)=>{
            console.log("Start replacing");
            let replacementPhone = await service.getReplacementPhone(phoneItem.getDigits(), this.timeout);
            console.log("Replacement Phone", replacementPhone);
            replacementPhone = replacementPhone ?? phoneItem.getDigits();
            const siblings = this.phonesMap.get(phoneItem.getInitialDigits());
            if (siblings) for (const sibling of siblings)sibling.revealPhone(replacementPhone);
        });
    }
}


// @ts-ignore
var $bfba8206659442e5$exports = {};
$bfba8206659442e5$exports = "tracked-phone{position:relative}tracked-phone[cloaked]{-webkit-mask-image:linear-gradient(90deg,#fff 0% 20%,#0000001a 80%,#00000005 90%);mask-image:linear-gradient(90deg,#fff 0% 20%,#0000001a 80%,#00000005 90%)}tracked-phone[loading]:after{content:\"\";background:linear-gradient(110deg,#fffc 5%,#fff0 20%,#fffc 80%) 0 0/200% 100%;animation:.7s linear infinite shine;position:absolute;inset:0}@keyframes shine{to{background-position-x:-200%}}";


function $e3c97dfc8d018c6b$export$e5c45ca1e113bfed() {
    const styleElement = document.createElement("style");
    styleElement.textContent = (0, (/*@__PURE__*/$parcel$interopDefault($bfba8206659442e5$exports)));
    document.head.appendChild(styleElement);
}


// eslint-disable-next-line @typescript-eslint/no-unused-vars
class $c1d679853bf59bf7$var$TrackedPhonesCloaker {
    constructor(config){
        (0, $6dede80f470fc4d9$export$feb348eaf4031ce3)();
        (0, $e3c97dfc8d018c6b$export$e5c45ca1e113bfed)();
        const phonesMap = new Map();
        const wrappersSet = new Set();
        const processor = new (0, $1010654e42cdef29$export$c30cd198d731db19)(phonesMap, wrappersSet, config);
        processor.processAllPhones();
        setInterval(()=>processor.processAllPhones(), 1000);
    }
}
window["TrackedPhonesCloaker"] = $c1d679853bf59bf7$var$TrackedPhonesCloaker;


//# sourceMappingURL=index.054d0c72.js.map
